import { render, staticRenderFns } from "./DashboardTickets.vue?vue&type=template&id=65db3f8c&scoped=true"
import script from "./DashboardTickets.vue?vue&type=script&lang=js"
export * from "./DashboardTickets.vue?vue&type=script&lang=js"
import style0 from "./DashboardTickets.vue?vue&type=style&index=0&id=65db3f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db3f8c",
  null
  
)

export default component.exports